var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Refer & Earn ")]),
      _c("gg-card-text", [
        _c(
          "div",
          {
            attrs: {
              id: "affiliates-top-banner"
            }
          },
          [
            _c(
              "div",
              {
                staticClass: "d-flex flex-column"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "text-center"
                  },
                  [
                    _vm.hasAffiliateAccount
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "py-3"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "d-block pb-2"
                                },
                                [_vm._v("You’ve earned this month:")]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "font-weight-light d-block affiliate-earned py-6 primary--text"
                                },
                                [_vm._v(" " + _vm._s(_vm.paidCommission) + " ")]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "d-block pb-2"
                                },
                                [_vm._v("Your Referral Link:")]
                              ),
                              _c(
                                "span",
                                {
                                  ref: "affiliateUrl"
                                },
                                [
                                  _vm._v(
                                    " https://www.greengeeks.com/track/" +
                                      _vm._s(
                                        _vm.SessionProfile.affiliate_username
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "gg-btn",
                                {
                                  attrs: {
                                    icon: ""
                                  },
                                  on: {
                                    click: function click($event) {
                                      return _vm.copyToClipboard("affiliateUrl")
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "visually-hidden"
                                    },
                                    [_vm._v("Copy")]
                                  ),
                                  _c(
                                    "v-icon",
                                    {
                                      attrs: {
                                        small: ""
                                      }
                                    },
                                    [_vm._v("mdi-content-copy")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      : [
                          _c(
                            "div",
                            {
                              staticClass: "py-3"
                            },
                            [
                              _c(
                                "h4",
                                {
                                  staticClass:
                                    "d-block text-center mb-6 font-weight-light"
                                },
                                [
                                  _vm._v(
                                    " Refer your family and friends and earn money. "
                                  )
                                ]
                              ),
                              _c(
                                "gg-btn",
                                {
                                  staticClass: "px-5",
                                  attrs: {
                                    to: {
                                      name: "affiliates"
                                    }
                                  }
                                },
                                [_vm._v(" Get Link ")]
                              )
                            ],
                            1
                          )
                        ]
                  ],
                  2
                )
              ]
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }